module.exports = __webpack_public_path__ + "media/sceen-video.980b8368.mp4";